export const OPPORTUNITY_COVER_WIDTH = 1984
export const OPPORTUNITY_COVER_HEIGHT = 531
export const OPPORTUNITY_COVER_ASPECT_RATIO = OPPORTUNITY_COVER_WIDTH / OPPORTUNITY_COVER_HEIGHT
export const OPPORTUNITY_COVER_MAX_DISPLAY_HEIGHT = 350
export const OPPORTUNITY_COVER_MAX_DISPLAY_WIDTH = Math.round(
  (OPPORTUNITY_COVER_MAX_DISPLAY_HEIGHT * OPPORTUNITY_COVER_WIDTH) / OPPORTUNITY_COVER_HEIGHT
)

export const OPPORTUNITY_DETAIL_COVER_MAX_WIDTH = 1308
export const OPPORTUNITY_DETAIL_COVER_ASPECT_WIDTH = 1500
export const OPPORTUNITY_DETAIL_COVER_ASPECT_HEIGHT = 500
export const OPPORTUNITY_STARTUP_LIST_THUMBNAIL_WIDTH = 380
export const OPPORTUNITY_STARTUP_LIST_THUMBNAIL_HEIGHT = Math.round(
  (OPPORTUNITY_STARTUP_LIST_THUMBNAIL_WIDTH * OPPORTUNITY_COVER_HEIGHT) / OPPORTUNITY_COVER_WIDTH
)

export const OPPORTUNITY_FORM_COVER_RECOMMENDED_WIDTH = 380
export const OPPORTUNITY_FORM_COVER_RECOMMENDED_HEIGHT = 126
export const OPPORTUNITY_FORM_COVER_ASPECT_RATIO =
  OPPORTUNITY_FORM_COVER_RECOMMENDED_WIDTH / OPPORTUNITY_FORM_COVER_RECOMMENDED_HEIGHT
export const OPPORTUNITY_COMPANY_LIST_THUMBNAIL_WIDTH = 280
export const OPPORTUNITY_COMPANY_LIST_THUMBNAIL_HEIGHT = 95
